<mat-form-field #formFieldContainer [floatLabel]="!isMobileDetect?'auto':'always' " class="date-time-class" style="overflow:hidden;background: #fafafa;">
  <mat-label
    #labelContainer
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>
  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}">
  </div>
  <input #textInput matInput placeholder="{{ componentDefinition.label }}"
         (blur)="validateDate()"
         [(ngModel)]="displayDate"
         [errorStateMatcher]="matcher"
         [readonly]="!allowInput"
  >

  <input #dateInputRef
         type="{{dateInputType}}"
         inputmode="none"
         [(ngModel)]="dateInput"
         style="position:absolute;left:0;width:100%;bottom:0;height:0;z-index: -2;outline:none;border:none;"
        (input)="onChangeHandler($event)"
  />
  <input #hiddenInput type="hidden"
         [id]="elementName + document.documentId"
         [name]="componentDefinition.name"
         [formControl]="formControl"/>

  <button type="button" data-toggle matSuffix mat-icon-button
          (click)="validateDate()"
          [hidden]="!allowInput"
          title="Open Calendar">
    <mat-icon>event_available</mat-icon>
  </button>
  <button type="button" data-toggle matSuffix mat-icon-button
          (click)="showPicker($event)"
           title="Open Calendar">
    <mat-icon>today</mat-icon>
  </button>

</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
